import React from "react";
import styles from "./HowItWorksSection.module.css";
import { Container } from "../../common/Container";
import { howItWorksData } from "../../../data/compassData";

// Glyphs echo the app: a value's own icon, the compass for a direction, a check for a habit.
const glyphs: Record<string, React.ReactNode> = {
  Value: (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M4.5 6.375a4.125 4.125 0 118.25 0 4.125 4.125 0 01-8.25 0zM14.25 8.625a3.375 3.375 0 116.75 0 3.375 3.375 0 01-6.75 0zM1.5 19.125a7.125 7.125 0 0114.25 0v.003l-.001.119a.75.75 0 01-.363.63 13.067 13.067 0 01-6.761 1.873c-2.472 0-4.786-.684-6.76-1.873a.75.75 0 01-.364-.63l-.001-.122zM17.25 19.128l-.001.144a2.25 2.25 0 01-.233.96 10.088 10.088 0 005.06-1.01.75.75 0 00.42-.643 4.875 4.875 0 00-6.957-4.611 8.586 8.586 0 011.71 5.157v.003z" />
    </svg>
  ),
  Direction: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="12" r="9" />
      <path d="M15.5 8.5l-2 5-5 2 2-5 5-2z" fill="currentColor" stroke="none" />
    </svg>
  ),
  Habit: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.4} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M5 12.5l4.5 4.5L19 7.5" />
    </svg>
  ),
};

export const HowItWorksSection: React.FC = () => (
  <section id="how-it-works" className={styles.section} aria-labelledby="how-it-works-title">
    <Container>
      <div className={styles.header}>
        <h2 id="how-it-works-title" className={styles.title}>
          Every habit points back to something you care about.
        </h2>
        <p className={styles.subtitle}>
          Most habit trackers give you a checklist. Compass starts one level up, so each small
          action has a reason behind it.
        </p>
      </div>

      <ol className={styles.chain}>
        {howItWorksData.map((step) => (
          <li key={step.step} className={styles.step}>
            <span className={styles.kind}>{step.kind}</span>
            <div className={styles.row} data-kind={step.kind}>
              <span className={styles.glyph}>{glyphs[step.kind]}</span>
              <span className={styles.example}>{step.example}</span>
            </div>
            <p className={styles.description}>{step.description}</p>
          </li>
        ))}
      </ol>
    </Container>
  </section>
);
